<template>
<nav class="level">
  <div class="level-left">
    <div class="level-item">
      <p class="subtitle is-5">
        <strong class="title">
          Sounds
        </strong>
      </p>
    </div>
  </div>
  <div class="level-right">
    <div class="level-item">
    </div>
    <div class="level-item">
      <button
        class="button is-primary is-rounded"
        @click="this.uploadActive=true">
        <span>Upload Files</span>
        <span class="icon"><i class="fas fa-upload"></i></span>
      </button>
    </div>
  </div>
</nav>

<nav class="level">
  <div class="level-left">
    <div style="margin-right: 12px">
      <label class="label">Start Date</label>
      <div class="control" @click="this.dates_touched=true">
        <input
          class="input"
          :class="{'is-danger': daysOver60}"
          type="date"
          v-model="start_date" >
      </div>
    </div>
    <div style="margin-right: 12px">
      <label class="label">End Date</label>
      <div class="control" @click="this.dates_touched=true">
        <input
          class="input"
          :class="{'is-danger': daysOver60}"
          type="date"
          v-model="end_date" >
      </div>
    </div>
  </div>
  <div class="level-right" style="padding-top: 32px">
    <div class="level-item">
      <div class="field">
        <div class="control">
          <input
            class="input"
            v-model="filter_name"
            placeholder="Filter Name"
            v-on:keyup.enter="applyFilters" >
        </div>
      </div>
    </div>
    <div class="level-item">
      <div class="field">
        <div class="control">
          <input
            class="input"
            v-model="filter_device"
            placeholder="Filter Device"
            v-on:keyup.enter="applyFilters" >
        </div>
      </div>
    </div>
    <div class="level-item">
      <div class="field">
        <div class="control">
          <div class="select">
            <select v-model="limit" @change="applyLimit">
              <option v-for="item in limits" :value="item">{{ item }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>

<nav class="level" v-if="daysOver60">
    <div class="level-left">
        <div class="level-item">
            <p>Max date range is 60 days</p>
        </div>
    </div>
</nav>

<nav class="level">
    <div class="level-left">
        <div class="level-item">
            <DropDown
                v-if="species.length > 0"
                :items="species"
                starter-text="Filter US common name"
                :switchToSelected="true"
                custom-icon-class="fa-solid fa-dove"
                :disabled="false"
                :useTextInput="true"
                @selected="onSpecieSelected"
                :update-selected="updateDropdown"
            />
        </div>
        <!-- <div class="level-item">
            <div class="field">
                <o-switch
                    v-model="species_filter_type"
                    true-value="latin"
                    false-value="common_us">
                    {{ species_filter_type }}
                </o-switch>
            </div>
        </div> -->
    </div>
    <div class="level-right">
        <div v-if="isAdmin" class="level-item">
            <div class="field">
                <div class="control">
                    <input
                        class="input"
                        v-model="filter_user"
                        placeholder="enter an email address"
                        v-on:keyup.enter="applyFilters"  >
                </div>
            </div>
        </div>
        <div v-if="isAdmin" class="level-item">
            <div class="field">
                <div class="control">
                    <div class="select">
                        <select v-model="selectedMode">
                            <option value="table">Table View</option>
                            <option value="cards">Card View</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</nav>

<nav class="level">
  <div class="level-left">
    <div class="level-item">
      <button
        :disabled="daysOver60"
        class="button"
        @click="applyFilters">
        Apply Filters
      </button>
    </div>
    <div class="level-item">
      <button
        class="button"
        @click="resetFilters">
        Reset
      </button>
    </div>
  </div>

    <div class="level-right">
        <div v-if="isAdmin" class="level-item">
            <DropDown
                v-if="isAdmin && tickedFileList.length > 0"
                :items="allowedBulkActions"
                starter-text="Action"
                :switchToSelected="false"
                custom-icon-class="fa-solid fa-laptop"
                :disabled="false"
                :useTextInput="false"
                @selected="onBulkActionSelected">
            </DropDown>
        </div>
    </div>
</nav>

<template v-if="activeBulkMessage">
    <NotificationMessage
        class="p-5 m-2"
        bulmaColorClass="is-primary"
        @delete-msg-clicked="activeBulkMessage = null">
        <p>{{ activeBulkMessage }}</p>
    </NotificationMessage>
</template>

<LoadingSpinner v-if="loading" class="m-3"/>

<div v-else>
    <span>
        <span v-if="selectedMode == 'table'">
            <SoundTable
                v-model="tickedFileList"
                :sounds="this.sounds"
                :page="this.page"
                :limit="this.limit"
                :requesting_user="this.requesting_user"
                :is-admin="isAdmin"
                @sort="sortCol"
                @download-sound="downloadSoundEvent"
                @file-deleted="refreshSounds">
            </SoundTable>
        </span>
        <span v-if="selectedMode == 'cards'">
            <SoundBoxes
                :sounds="sounds"
                :requesting-user="requesting_user"
                @file-deleted="refreshSounds">
            </SoundBoxes>
        </span>
    </span>

    <nav class="level">
        <p class="level-item">
            <a class="icon" @click="changePage(-1)">
                <i class="fas fa-arrow-left "></i>
            </a>
        </p>
        <p class="level-item">
            {{ page }}
            <span class="icon" v-if="this.loading"><i class="fas fa-sync fa-spin"></i></span>
        </p>
        <p class="level-item">
            <a class="icon" @click="changePage(1)">
                <i class="fas fa-arrow-right "></i>
            </a>
        </p>
    </nav>
</div>
<!-- Upload Files Modal -->
<ModalSimple
  @closed="this.uploadActive=false"
  :active="this.uploadActive"
  title="Upload Sound">
  <UploadSound @uploaded="uploadedEvent"/>
</ModalSimple>

<!-- Actions Modal -->
<template v-if="activeBulkItem">
    <ModalSimple
        :active="activeBulkItem"
        @closed="activeBulkItem = null"
        :title="activeBulkItem.visualName"
    >
        <PillsManager
            v-model="tickedFileList"
            pills-class="has-background-white">  
        </PillsManager>

        <BulkActionsManager
            :sound-ids="tickedFileListIds"
            :requesting-user="requesting_user"
            :token="id_token"
            :active-bulk-item="activeBulkItem"
            @bulk-action-complete="onBulkActionComplete">
        </BulkActionsManager>

    </ModalSimple>
</template>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import ModalSimple from '@/widgets/ModalSimple.vue'
import SoundTable from '@/components/sounds/SoundTable.vue'
import SoundBoxes from '@/components/sounds/SoundBoxes.vue'
import UploadSound from '@/components/sounds/UploadSound.vue'
import DropDown from '@/widgets/DropDown.vue'
import LoadingSpinner from '@/widgets/LoadingSpinner.vue'
import { nextTick } from 'vue'
import NotificationMessage from '@/widgets/NotificationMessage.vue'
import PillsManager from '@/components/sounds/bulk-actions/PillsManager.vue'
import { bulkActions } from '@/components/sounds/bulk-actions/BulkActionsManager.vue';
import BulkActionsManager from '@/components/sounds/bulk-actions/BulkActionsManager.vue'
// js
import { useLogin  } from '@/js/auth.js'
import { getSounds, deleteSound, getSoundUrlRead, getSpecieList } from '@/js/apis.js'

function getOffsetDate(offset, initial){
    let d;
    if (initial) {
        d = new Date(initial);
    } else {
        d = new Date();
    }
    if (offset) {
        d.setDate(d.getDate() - offset);
    }
    return d.toISOString().substr(0, 10);
}

export default {
    components: { 
        UploadSound,
        ModalSimple,
        SoundTable,
        SoundBoxes,
        DropDown,
        LoadingSpinner,
        NotificationMessage,
        PillsManager,
        BulkActionsManager,
    },
    data(){
        return {
            sounds: [],
            selectedMode: "table",
            filter_name: "",
            filter_device: "",
            filter_user: "",
            uploadActive: false,
            limit: 10,
            limits: [10, 20, 50, 100, 300, 500, 1000],
            loading: false,
            start_date: "",
            end_date: "",
            dates_touched: false,
            species_filter: '',
            species_filter_type: 'common_name',
            species: '',
            updateDropdown: null,
            tickedFileList: [],
            activeBulkItem: null,
            activeBulkMessage: null,
        }
    },
    async mounted() {
        this.species = await this.prepSpecies()

        var filter_user = this.$route.query.filter_user
        if (filter_user) {
            if (this.isAdmin && filter_user.length > 0){
                this.filter_user = filter_user
            }
        }
        var filter_device = this.$route.query.filter_device
        if (filter_device) {
            if (filter_device.length > 0){
                this.filter_device = filter_device
            }
        }
        var filter_name = this.$route.query.filter_name
        if (filter_name) {
            if (filter_name.length > 0){
                this.filter_name = filter_name
            }
        }
        var limit = this.$route.query.limit
        if (limit) {
            limit = parseInt(limit)
            if (!isNaN(limit) && this.limits.includes(limit)) {
                this.limit = limit
            }
        }
        var start_date = this.$route.query.start_date
        var days = this.$route.query.days
        if (!days){
            days = 14
        } else {
            // TODO: need to check for negative days,
            // NaN, and other edge conditions
            days = parseInt(days)
            this.dates_touched = true
        }
        if (start_date) {
            this.start_date = start_date
            this.dates_touched = true
        } else {
            this.start_date = getOffsetDate(days)
        }
        this.end_date = getOffsetDate(-days, this.start_date)
        var species_filter = this.$route.query.species_filter
        if (species_filter) {
            if (species_filter.length > 0){
                this.species_filter = species_filter
                this.updateDropdown = species_filter
            }
        }
        var species_filter_type = this.$route.query.species_filter_type
        if (species_filter_type) {
            if (species_filter_type.length > 0){
                this.species_filter_type = species_filter_type
            }
        }
        this.refreshSounds()
    },
    methods: {
        downloadSoundEvent(event){
            console.log("downloadSoundEvent", event)
            getSoundUrlRead(this.requesting_user, event.sound.object_key)
                .then((res, err) => {
                    window.open(res.url);
                })
        },
        sortCol(event){
            console.log("Sounds.sortCol (not implemented yet):", event)
            this.refreshSounds()
        },
        async resetFilters(){
            this.filter_user = ""
            this.filter_device = ""
            this.filter_name = ""
            this.start_date = getOffsetDate(14)
            this.end_date = getOffsetDate(0)
            this.species_filter = ''
            this.species_filter_type = 'common_name'
            await this.resetDropdown()
            this.applyFilters()
        },
        async resetDropdown(new_value = '') {
            // ensuring update dropdown reactivity
            this.updateDropdown = null
            await nextTick()
            this.updateDropdown = new_value
        },
        applyFilters(){
            // run applyFilters only if the user has selected a valid date range
            if (!this.daysOver60) {
                let copy = {
                  page: 1,
                  limit: this.$route.query.limit
                }
                if (this.filter_device){
                    copy.filter_device = this.filter_device
                }
                if (this.filter_name){
                    copy.filter_name = this.filter_name
                }
                if (this.isAdmin && this.filter_user.length > 6){
                    copy.filter_user = this.filter_user
                }
                if (this.dates_touched){
                    if (this.start_date){
                        copy.start_date = this.start_date
                    }
                    if (this.days > 0){
                        copy.days = this.days
                    }
                }
                if (this.species_filter) {
                    copy.species_filter = this.species_filter
                    copy.species_filter_type = this.species_filter_type
                }
                this.$router.replace({query: copy})
            } else {
                console.error('days must be < 60')
            }
        },
        applyLimit(){
            let copy = {}
            copy = {...this.$route.query}
            if (this.limit >= 10){
                copy.limit = this.limit
                if (this.$route.query.page > 1) {
                  copy.page = 1
                }
            }
            this.$router.replace({query: copy})
        },
        refreshSounds(){
            console.log("refresh...")
            this.loading = true
            getSounds(
                this.requesting_user,
                this.page,
                this.limit, {},
                this.filters,
                {"Authorization": `Bearer ${this.id_token}`})
                .then(res => {           
                    if (res != null){
                        console.log(`results length: ${res.length}`)
                        this.sounds = res.slice(0, this.limit)
                        if (res.length == 0){
                            this.changePage(-1)
                        }
                    } else {
                        console.log("bad response...")
                    }
                    this.loading = false
                })
        },
        uploadedEvent(){
            this.uploadActive=false
            this.refreshSounds()
        },
        changePageTo(val){
            if (val > 0) {
                var copy = {...this.$route.query}
                copy.page = val
                this.$router.replace({query: copy})
            }
        },
        changePage(val){
            let new_page = parseInt(this.page) + val
            this.changePageTo(new_page)
        },
        onSpecieSelected(event) {
            this.species_filter = event
        },
        async prepSpecies() {
            let speciesArray = await getSpecieList(10000000, this.id_token)
            // Assuming getSpecieList() returns an array
            if (Array.isArray(speciesArray)) {
                let speciesNames = speciesArray.map(species => {
                    let parts = species.split('_')
                    return parts.length > 1 ? parts[1] : null
                });
                return speciesNames
            } else {
                console.error('getSpecieList() did not return an array:', speciesArray);
            }
        },
        onBulkActionSelected(command){
            // Check that the command is valid
            for (const item of Object.values(bulkActions)){
                if (command === item.visualName){
                    // Check if the command requires admin
                    if (item.requiresAdmin){
                        if (this.isAdmin){
                            this.activeBulkItem = item
                        }
                    } else {
                        this.activeBulkItem = item
                    }
                }
            }
        },
        onBulkActionComplete(event){
            this.refreshSounds()
            this.tickedFileList = []
            if (event.apiResponse){
                if (event.apiResponse.length > 0){
                    this.activeBulkMessage = bulkActions[event.action].message
                }
            }
            this.activeBulkItem = null
        },
    },
    computed: {
        ...mapState(useLogin, ["email", "isAdmin", "access_token", "id_token"]),
        requesting_user(){
            if (!this.isAdmin){
                return this.email
            }
            var filter_user = this.$route.query.filter_user
            if (!filter_user) {
                return this.email
            }
            if (filter_user.length > 5){
                return filter_user
            }
            return this.email
        },
        filters(){
            var this_filters = {}
            if (this.$route.query.filter_name) {
                this_filters.filter_name = this.$route.query.filter_name
            }
            if (this.$route.query.filter_device) {
                this_filters.filter_device = this.$route.query.filter_device
            }
            if (this.$route.query.species_filter) {
                this_filters.species_filter = this.$route.query.species_filter
            }
            if (this.$route.query.species_filter_type) {
                this_filters.species_filter_type = this.$route.query.species_filter_type
            }
            this_filters.start_date = this.start_date
            this_filters.days = this.days
            return this_filters
        },
        page() {
            if (this.$route.query.page) {
                return parseInt(this.$route.query.page)
            } else {
                return 1
            }
        },
        days(){
          let d1 = new Date(this.end_date);
          let d2 = new Date(this.start_date);
          return (d1 - d2)/1000/60/60/24;
        },
        daysOver60(){
            return this.days > 60 ? true : false
        },
        allowedBulkActions(){
            let adminCommands = []
            for (const item of Object.values(bulkActions)){
                // If anyone can use the command, add it
                if (item.requiresAdmin === false){
                    adminCommands.push(item.visualName)
                } else {
                    // If user is admin, add the others
                    if (this.isAdmin){
                        adminCommands.push(item.visualName)
                    }
                }
            }
            return adminCommands
        },
        tickedFileListIds(){
            return this.tickedFileList.map(
                (audioFile) => audioFile.object_key
            )
        },
    },
    watch: {
        $route() {
            if (this.page < 1){
                this.changePageTo(1)
            }
            this.refreshSounds()
        },
    }
}
</script>
